import React from "react";
import styled from "styled-components";
import t from "common/i18n";
import { globalTheme } from "@cld/component-theme";
import { useFilterParams, useSearchParams, useUI } from "../../selectors";
import { secondsToMinutes } from "../../utils";
import { FILTERS_BY_MEDIA_TYPE } from "../../data/consts";

export const SummaryBox = styled.div`
	padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	font-weight: bold;
	display: flex;
	flex-wrap: wrap;
`;


const ElementBox = styled.div`
	display: flex;
	padding-right: ${globalTheme.spacing.xxs}
`;
const ColorFilterBox = styled.div`
	display: flex;
`;
export const ColorBox = styled.div`
	width: 12px;
	height: 12px;
	border-radius: ${globalTheme.radius.md};
	background: ${({ color }) => color};
	border: 1px solid ${globalTheme.palette.secondary};
	position: relative;
	top: 1px;
	left: 3px;
`;


export default () => {
	const { orientations, numberOfPeople, licenseType, color, ageOfPeople, formatAvailable, duration, excludeNudity } = useFilterParams();
	const { searchPhrase, mediaType } = useSearchParams();
	const { areFiltersSet } = useUI();
	const filterSet = FILTERS_BY_MEDIA_TYPE[mediaType];

	const filtersList = [];
	if (searchPhrase) {
		filtersList.push(`[${searchPhrase}]`);
	}
	if (filterSet.includes("license") && licenseType && areFiltersSet) {
		filtersList.push(t(`istock.filters.license.${licenseType}`));
	}
	if (filterSet.includes("orientations") && orientations && areFiltersSet) {
		filtersList.push(t(`istock.filters.orientation.${orientations}`));
	}
	if (filterSet.includes("numberOfPeople") && numberOfPeople && areFiltersSet) {
		filtersList.push(t(`istock.filters.summary.number_of_people.${numberOfPeople}`));
	}
	if (filterSet.includes("ageOfPeople") && ageOfPeople && areFiltersSet) {
		filtersList.push(t(`istock.filters.age_of_people.${ageOfPeople}`));
	}
	if (filterSet.includes("formatAvailable") && formatAvailable?.length && areFiltersSet) {
		filtersList.push(formatAvailable.join(", "));
	}
	if (filterSet.includes("duration") && duration && areFiltersSet) {
		filtersList.push(<>{secondsToMinutes(duration[0])} - {secondsToMinutes(duration[1])}</>);
	}
	if (filterSet.includes("more") && excludeNudity && areFiltersSet) {
		filtersList.push(t("istock.filters.more.safe"));
	}
	if (filterSet.includes("color") && color && areFiltersSet) {
		filtersList.push(<ColorFilterBox>{t("istock.filters.summary.color", { color })}<ColorBox color={color} /></ColorFilterBox>);
	}

	return <>{(searchPhrase || areFiltersSet) &&
		<SummaryBox data-test="filters-summary">
			<ElementBox>
				{t("istock.filters.summary.label")}:
			</ElementBox>
			{filtersList.map((item, i) => (
				<ElementBox key={i}>
					{item}
					{i >= 0 && i < filtersList.length - 1 ? "," : null}
				</ElementBox>
			))}
		</SummaryBox>
	}</>;
};
